import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const DateValue = ({ value, empty, format }) => {
	return <div className="string-value">{value ? moment(value).format(format) : empty}</div>;
};

DateValue.propTypes = {
	value: PropTypes.any,
	empty: PropTypes.string,
	format: PropTypes.string,
};

DateValue.defaultProps = {
	empty: '-',
	format: 'DD.MM.YYYY HH:mm',
};

export default DateValue;
